import React from 'react';
import PropTypes from 'prop-types';

import { Tooltip } from '@weezevent/nacre';
import { Icon } from 'semantic-ui-react';

import Style from './style/tooltip-icon.module.css';

export default function TooltipIcon({ content, inline, position = 'bottom', triggerOnHover = true, size = 'big', iconStyle = {}, ...rest }) {
    return (
        <Tooltip className={`${Style['tooltip-icon']} ${inline ? Style['inline'] : ''}`} triggerOnHover={triggerOnHover} position={position} {...rest} title={content}>
            <Icon name="question circle" size={size} style={{ color: 'gray', ...iconStyle }} className={Style[`icon-${size}`]} />
        </Tooltip>
    );
}

// @alaricweez if you ever read these PropTypes please open
// a Pull Request with a comment saying
// "I hereby certify having read the PropTypes definition for ToolTipIcon
// on dd/mm/yyyy"
TooltipIcon.propTypes = {
    content: PropTypes.node,
    position: PropTypes.string,
    triggerOnHover: PropTypes.bool,
    size: PropTypes.string,
    iconStyle: PropTypes.object
};
